import NamespaceRouter from './component'
export default NamespaceRouter
